module.exports = "function MyComponent(props) {\n  return <h1>Hello {props.name}</h1>;\n}\n\n\nconst MyComponent = (props) => (\n  <h1>Hello {props.name}</h1>\n);\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/10_components/functional.example
// module id = 1523
// module chunks = 0